import { AppBaseData } from '@src/common/app-basic-data';
import { DataResponse } from '@src/common/data-response';
import { withBasePath } from '@src/common/path-convert';
import { getSearchString } from '@src/utils/query-string';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import useSWR from 'swr';
export function useAppData(): DataResponse<AppBaseData> {
    const router = useRouter();
    const url = useMemo(
        () => withBasePath(`/api/app-data/${getSearchString() || '?'}&lang=${router.locale}`),
        [router.locale]
    );
    const appdata = useSWR<AppBaseData>(url);
    return appdata;
}
